const SETUP_INFO_FIELDS = {
  'vu-iptv': ['serverUrl', 'username', 'password'],
  uhf: ['serverUrl', 'username', 'password'],
  tivigo: ['username', 'password'],
  'tivigo-tv': ['username', 'password'],
  'tivigo-fire-tv': ['username', 'password'],
  'tivigo-ios': ['username', 'password'],
  'tivigo-lg-webos': ['username', 'password'],
  'tivigo-pc': ['username', 'password'],
  'tivigo-macos': ['username', 'password'],
  'smart-iptv': [],
  'ss-iptv': [],
  'asx-iptv': [],
  smartone: [],
  televizo: ['serverUrl', 'username', 'password'],
  'smarters-lite': ['serverUrl', 'username', 'password'],
  'cloud-stream': [],
  'iptvx-ios': ['serverUrl', 'username', 'password'],
  'xtream-plugin': ['serverUrl', 'username', 'password'],
  nextstar: [],
  'server-info': ['portalUrl', 'port', 'username', 'password'],
  m3u: [],
};

const SETUP_IMAGE_GUIDES = {
  'smart-iptv': [
    '/kurulumimg/sip1.png',
    '/kurulumimg/sip2.png',
    '/kurulumimg/sip3.png',
    '/kurulumimg/sip4.png',
    '/kurulumimg/sip5.png',
    '/kurulumimg/son.png',
  ],
  'ss-iptv': [
    '/kurulumimg/ss1.jpg',
    '/kurulumimg/ss2.jpg',
    '/kurulumimg/ss3.jpg',
    '/kurulumimg/ss4.jpg',
    '/kurulumimg/ss5.jpg',
    '/kurulumimg/ss6.jpg',
    '/kurulumimg/ss7.jpg',
    '/kurulumimg/son.png',
  ],
  'smarters-lite': [
    '/kurulumimg/ios1.jpeg',
    '/kurulumimg/ios2.jpeg',
    '/kurulumimg/ios3.jpeg',
    '/kurulumimg/ios4.jpeg',
    '/kurulumimg/ios5.jpeg',
    '/kurulumimg/son.png',
  ],
};

const SETUP_REVIEW_META = {
  tivigo: { rating: 5, commentCount: 2 },
  'tivigo-tv': { rating: 5, commentCount: 2 },
  'tivigo-fire-tv': { rating: 0, commentCount: 0 },
  'tivigo-ios': { rating: 5, commentCount: 2 },
  'tivigo-lg-webos': { rating: 5, commentCount: 2 },
  'tivigo-pc': { rating: 5, commentCount: 2 },
  'tivigo-macos': { rating: 5, commentCount: 2 },
  'smart-iptv': { rating: 3, commentCount: 2 },
  'ss-iptv': { rating: 2, commentCount: 2 },
  'asx-iptv': { rating: 3, commentCount: 2 },
  smartone: { rating: 2, commentCount: 2 },
  televizo: { rating: 3, commentCount: 2 },
  'smarters-lite': { rating: 5, commentCount: 2 },
  'cloud-stream': { rating: 3, commentCount: 2 },
  'iptvx-ios': { rating: 4, commentCount: 2 },
  'xtream-plugin': { rating: 5, commentCount: 2 },
  nextstar: { rating: 1, commentCount: 2 },
};

const createGuide = ({
  id,
  sourceId = id,
  name,
  description,
  setupType,
  logo,
  official = false,
  loading,
  steps,
  actionUrl = null,
  actionLabel = null,
  actionExternal = false,
  actionDownload = false,
  additionalActions = [],
  hasM3u = false,
}) => ({
  id,
  sourceId,
  name,
  description,
  setupType,
  logo,
  official,
  loading,
  steps,
  actionUrl,
  actionLabel,
  actionExternal,
  actionDownload,
  additionalActions,
  hasM3u,
  infoFields: SETUP_INFO_FIELDS[id] || [],
  imageGuide: SETUP_IMAGE_GUIDES[id] || [],
  review: SETUP_REVIEW_META[id] || null,
});

const TIVIGO_LOGO = '/assets/images/tivigo-app-icon.png';

const SETUP_DETAIL_GUIDES = {
  'vu-iptv': createGuide({
    id: 'vu-iptv',
    name: 'VU IPTV Player',
    description: 'iPhone ve iPad için IPTV oynatıcı',
    setupType: 'Xtream Codes',
    logo: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/23/31/0c/23310cfd-e04f-bf07-d172-74c957918f8b/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/512x512bb.jpg',
    loading: 'Elle Giriş',
    steps: [
      'iPhone’unuzda “App Store’dan İndir” düğmesiyle Byte9 Inc tarafından yayımlanan VU IPTV Player’ı yükleyin.',
      'Uygulamayı açıp yeni hesap veya oynatma listesi ekleme bölümüne girin.',
      '“Xtream Codes” giriş yöntemini seçin.',
      'Liste adı istenirse “Tivigo” yazın.',
      'Bu sayfadaki sunucu adresini, kullanıcı adınızı ve şifrenizi kopyalayıp ilgili alanlara yapıştırın.',
      'Bilgileri kaydedip kanal, film ve dizi listesinin yüklenmesini bekleyin.',
      'Bilgi: iOS 16 veya üzeri gerekir.',
    ],
    actionUrl: 'https://apps.apple.com/tr/app/vu-iptv-player/id6526480705',
    actionLabel: 'App Store’dan İndir',
    actionExternal: true,
  }),

  'uhf': createGuide({
    id: 'uhf',
    name: 'UHF',
    description: 'macOS için IPTV oynatıcı',
    setupType: 'Xtream Codes',
    logo: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/1f/e4/0b/1fe40b42-84a3-b793-dc77-a2df074f0268/uhf-ios-icon-0-0-1x_U007epad-0-1-0-85-220.png/512x512bb.jpg',
    loading: 'Elle Giriş',
    steps: [
      'Mac’inizde “App Store’dan İndir” düğmesiyle UHF - Love your IPTV uygulamasını yükleyin.',
      'Uygulamayı açıp yeni oynatma listesi ekleme bölümüne girin.',
      '“Xtream” liste türünü seçin.',
      'Liste adı istenirse “Tivigo” yazın.',
      'Bu sayfadaki sunucu adresini, kullanıcı adınızı ve şifrenizi kopyalayıp ilgili alanlara yapıştırın.',
      'Bilgileri kaydedip kanal, film ve dizi listesinin yüklenmesini bekleyin.',
      'Bilgi: Apple M1 veya üzeri işlemcili Mac ve macOS 13 veya üzeri gerekir.',
    ],
    actionUrl: 'https://apps.apple.com/tr/app/uhf-love-your-iptv/id6443751726?platform=mac',
    actionLabel: 'App Store’dan İndir',
    actionExternal: true,
  }),
  tivigo: createGuide({
    id: 'tivigo',
    sourceId: 'android',
    name: 'Tivigo Android',
    description: 'Tivigo’nun resmî Android uygulaması',
    setupType: 'Tivigo hesabı',
    logo: TIVIGO_LOGO,
    official: true,
    loading: 'Otomatik',
    steps: [
      'Android cihazınızda Google Play Store’u açın.',
      'Arama alanına “Tivigo” yazıp uygulamayı seçin.',
      'Tivigo uygulamasını yükleyip açın.',
      'Kullanıcı adınızı ve şifrenizi girin.',
      '“Giriş Yap” düğmesine tıklayın.',
      'Kanal listeniz otomatik yüklenir.',
    ],
    actionUrl: 'https://play.google.com/store/apps/details?id=com.tivigo&hl=tr',
    actionLabel: "Google Play'den İndir",
    actionExternal: true,
    additionalActions: [
      {
        url: '/uygulama/tivigo.apk',
        label: 'APK İndir',
        download: true,
      },
    ],
  }),

  'tivigo-tv': createGuide({
    id: 'tivigo-tv',
    sourceId: 'android',
    name: 'Tivigo Android TV',
    description: 'Tivigo’nun resmî Android TV uygulaması',
    setupType: 'Tivigo hesabı',
    logo: TIVIGO_LOGO,
    official: true,
    loading: 'Otomatik',
    steps: [
      'Android TV’nizde Google Play Store’u açın.',
      'Arama alanına “Tivigo” yazıp uygulamayı seçin.',
      'Tivigo uygulamasını yükleyip açın.',
      'Kullanıcı adınızı ve şifrenizi girin.',
      '“Giriş Yap” düğmesine tıklayın.',
      'Kanal listeniz otomatik yüklenir.',
    ],
    actionUrl: 'https://play.google.com/store/apps/details?id=com.tivigo&hl=tr',
    actionLabel: "Google Play'den İndir",
    actionExternal: true,
  }),

  'tivigo-fire-tv': createGuide({
    id: 'tivigo-fire-tv',
    sourceId: 'fire-tv',
    name: 'Tivigo Fire TV',
    description: 'Tivigo’nun resmî Amazon Fire Stick TV uygulaması',
    setupType: 'Tivigo hesabı',
    logo: TIVIGO_LOGO,
    official: true,
    loading: 'Otomatik',
    steps: [
      'Fire TV cihazınızda Amazon Appstore’u açın.',
      'Arama alanına “Tivigo” yazıp uygulamayı seçin.',
      'Tivigo uygulamasını yükleyip açın.',
      'Kullanıcı adınızı ve şifrenizi girin.',
      '“Giriş Yap” düğmesine tıklayın.',
      'Kanal listeniz otomatik yüklenir.',
    ],
    actionUrl: 'https://www.amazon.in/dp/B0HJB36MXT',
    actionLabel: 'Amazon Appstore’dan İndir',
    actionExternal: true,
  }),

  'tivigo-ios': createGuide({
    id: 'tivigo-ios',
    sourceId: 'ios',
    name: 'Tivigo iOS',
    description: 'Tivigo’nun resmî iOS uygulaması',
    setupType: 'Tivigo hesabı',
    logo: TIVIGO_LOGO,
    official: true,
    loading: 'Otomatik',
    steps: [
      'Tivigo uygulamasını App Store’dan yükleyin.',
      'Uygulamayı açın.',
      'Kullanıcı adınızı ve şifrenizi girin.',
      '“Giriş Yap” düğmesine tıklayın.',
      'Kanal listeniz otomatik yüklenir.',
    ],
  }),

  'tivigo-lg-webos': createGuide({
    id: 'tivigo-lg-webos',
    sourceId: 'lg',
    name: 'Tivigo LG webOS',
    description: 'Tivigo’nun resmî LG webOS uygulaması',
    setupType: 'Tivigo hesabı',
    logo: TIVIGO_LOGO,
    official: true,
    loading: 'Otomatik',
    steps: [
      'LG Content Store’u açın.',
      'Arama alanına “Tivigo” yazın.',
      'Tivigo uygulamasını yükleyip açın.',
      'Kullanıcı adınız ve şifrenizle giriş yapın.',
    ],
  }),

  'tivigo-pc': createGuide({
    id: 'tivigo-pc',
    sourceId: 'windows',
    name: 'Tivigo Windows',
    description: 'Tivigo’nun resmî Windows uygulaması',
    setupType: 'Tivigo hesabı',
    logo: TIVIGO_LOGO,
    official: true,
    loading: 'Otomatik',
    steps: [
      'Tivigo Windows uygulamasını indirin.',
      'İndirilen .exe dosyasını çalıştırıp kurulumu tamamlayın.',
      'Uygulamayı açın.',
      'Kullanıcı adınızı ve şifrenizi girin.',
      '“Giriş Yap” düğmesine tıklayın.',
      'Kanal listeniz otomatik yüklenir.',
    ],
    actionUrl: '/uygulama/Tivigo_0.1.49_x64-setup.exe',
    actionLabel: 'Uygulamayı İndir',
    actionDownload: true,
  }),

  'tivigo-macos': createGuide({
    id: 'tivigo-macos',
    sourceId: 'macos',
    name: 'Tivigo macOS',
    description: 'Tivigo’nun resmî macOS uygulaması',
    setupType: 'Tivigo hesabı',
    logo: TIVIGO_LOGO,
    official: true,
    loading: 'Otomatik',
    steps: [
      'Tivigo macOS uygulamasını indirin.',
      'İndirilen .dmg dosyasını açın.',
      'Tivigo uygulamasını Applications klasörüne sürükleyin.',
      'Güvenlik uyarısı görüntülenirse “Sistem Ayarları > Gizlilik ve Güvenlik > Yine de Aç” yolunu izleyin.',
      'Uygulamayı açın.',
      'Kullanıcı adınızı ve şifrenizi girin.',
      '“Giriş Yap” düğmesine tıklayın.',
      'Kanal listeniz otomatik yüklenir.',
    ],
    actionUrl: '/uygulama/Tivigo-Macos.dmg',
    actionLabel: 'Uygulamayı İndir',
    actionDownload: true,
  }),

  'smart-iptv': createGuide({
    id: 'smart-iptv',
    name: 'Smart IPTV',
    description: 'Samsung ve LG Smart TV’ler için IPTV oynatıcı',
    setupType: 'M3U ile kurulum',
    logo: '/kurulum-icon/smartiptv.webp',
    loading: 'Manuel',
    steps: [
      'TV’nizin uygulama mağazasından Smart IPTV’yi yükleyip açın.',
      'Ekrandaki MAC/ID bilgisini not alın.',
      '“Uygulamanın Sitesine Git” düğmesine tıklayın.',
      'MAC/ID bilgisini ilgili alana girin.',
      '“M3U Dosyanız” bölümünden bağlantınızı oluşturup “URL” alanına yapıştırın.',
      '“Send” düğmesine tıklayın.',
      'Uygulamayı yeniden başlatın.',
      'Bilgi: Aktivasyon cihaz başına tek seferlik 5,49 €’dur.',
    ],
    actionUrl: 'https://siptv.app/mylist/',
    actionLabel: 'Uygulamanın Sitesine Git',
    actionExternal: true,
    hasM3u: true,
  }),

  'ss-iptv': createGuide({
    id: 'ss-iptv',
    name: 'SS IPTV',
    description: 'LG ve desteklenen Samsung Smart TV’ler için IPTV oynatıcı',
    setupType: 'M3U ile kurulum',
    logo: '/kurulum-icon/ssiptv.png',
    loading: 'Manuel',
    steps: [
      'LG TV’nizde SS IPTV’yi LG Content Store’dan yükleyin.',
      'Samsung TV’de resmî USB kurulumunu uygulayın: ss-iptv.com/en/users/documents/installing.',
      'Uygulamada “Settings” > “General” > “Get Code” yolundan bağlantı kodunu alın.',
      '“Uygulamanın Sitesine Git” düğmesine tıklayın.',
      'Kodu “Enter Connection Code” alanına girip “Add Device” düğmesine tıklayın.',
      '“External Playlists” bölümünde “Add Item” seçeneğini açın.',
      'M3U bağlantınızı “Source” alanına yapıştırıp kaydedin.',
      'TV’deki uygulamayı yenileyin.',
    ],
    actionUrl: 'https://ss-iptv.com/en/users/playlist',
    actionLabel: 'Uygulamanın Sitesine Git',
    actionExternal: true,
    hasM3u: true,
  }),

  'asx-iptv': createGuide({
    id: 'asx-iptv',
    name: 'ASX IPTV',
    description: 'Smart TV’ler için M3U destekli IPTV oynatıcı',
    setupType: 'M3U ile kurulum',
    logo: '/kurulum-icon/asx.png',
    loading: 'Manuel',
    steps: [
      'TV’nizin uygulama mağazasından ASX IPTV’yi yükleyip açın.',
      'Ekrandaki MAC adresini not alın.',
      '“Uygulamanın Sitesine Git” düğmesine tıklayın.',
      'MAC adresinizi ilgili alana girin.',
      'M3U bağlantınızı “Playlist URL” alanına yapıştırın.',
      '“Playlist Upload” düğmesine tıklayıp uygulamayı yeniden başlatın.',
    ],
    actionUrl: 'https://asxiptv.net/playist_editor',
    actionLabel: 'Uygulamanın Sitesine Git',
    actionExternal: true,
    hasM3u: true,
  }),

  smartone: createGuide({
    id: 'smartone',
    name: 'SmartOne',
    description: 'Smart TV platformları için IPTV oynatıcı',
    setupType: 'M3U ile kurulum',
    logo: '/kurulum-icon/smartone.png',
    loading: 'Manuel',
    steps: [
      'TV’nizin uygulama mağazasından SmartOne’ı yükleyip açın.',
      'Ekrandaki MAC adresini not alın.',
      '“Uygulamanın Sitesine Git” düğmesine tıklayın.',
      '“Xtream Playlist” sekmesini açın.',
      'MAC adresini, liste adını ve M3U bağlantısını girin.',
      '“Add Playlist” düğmesine tıklayın.',
      'Uygulamayı yeniden başlatın.',
      'Bilgi: Lisans cihaz başına 12,99 € kalıcı veya yıllık 2,50 €’dur.',
    ],
    actionUrl: 'https://www.smartone-iptv.com/plugin/smart_one/main_generate',
    actionLabel: 'Uygulamanın Sitesine Git',
    actionExternal: true,
    hasM3u: true,
  }),

  televizo: createGuide({
    id: 'televizo',
    name: 'Televizo',
    description: 'Android telefon, tablet ve TV için IPTV oynatıcı',
    setupType: 'Xtream Codes',
    logo: '/kurulum-icon/televizo.png',
    loading: 'Elle Giriş',
    steps: [
      'Televizo’yu Google Play Store’dan yükleyip açın.',
      '“Yeni liste oluştur” seçeneğine tıklayın.',
      '“Yeni Xtream Codes liste” seçeneğini seçin.',
      'Profil adı, sunucu URL’si, kullanıcı adı ve şifre bilgilerini girin.',
      'Sağ üstteki onay işaretine tıklayın.',
      'Kanal listeniz otomatik yüklenir.',
    ],
    actionUrl: 'https://play.google.com/store/apps/details?id=com.ottplay.ottplay&hl=tr',
    actionLabel: "Google Play'den İndir",
    actionExternal: true,
  }),

  'smarters-lite': createGuide({
    id: 'smarters-lite',
    sourceId: 'smarters-lite-ios',
    name: 'Smarters Player Lite',
    description: 'iPhone, iPad ve Apple TV için medya oynatıcı',
    setupType: 'Xtream Codes',
    logo: '/kurulum-icon/smarters_lite.webp',
    loading: 'Elle Giriş',
    steps: [
      'Smarters Player Lite’ı App Store’dan yükleyip açın.',
      '“Add New User” seçeneğine tıklayın.',
      '“Login with Xtream Codes API” seçeneğini seçin.',
      'Liste adı, sunucu URL’si, kullanıcı adı ve şifre bilgilerini girin.',
      '“Add User” düğmesine tıklayın.',
      'Oluşturulan profili seçin.',
    ],
    actionUrl: 'https://apps.apple.com/tr/app/smarters-player-lite/id1628995509?l=tr',
    actionLabel: "App Store'dan İndir",
    actionExternal: true,
  }),

  'cloud-stream': createGuide({
    id: 'cloud-stream',
    name: 'Cloud Stream IPTV',
    description: 'iPhone, iPad ve Apple TV için M3U oynatıcı',
    setupType: 'M3U bağlantısı',
    logo: '/kurulum-icon/cloudstream.webp',
    loading: 'Elle Giriş',
    steps: [
      'Cloud Stream IPTV Player’ı App Store’dan yükleyip açın.',
      'Yeni oynatma listesi ekleme seçeneğini açın.',
      'M3U bağlantınızı URL alanına yapıştırın.',
      'Listeyi kaydedip açın.',
    ],
    actionUrl: 'https://apps.apple.com/tr/app/cloud-stream-iptv-player/id1138002135?l=tr',
    actionLabel: "App Store'dan İndir",
    actionExternal: true,
    hasM3u: true,
  }),

  'iptvx-ios': createGuide({
    id: 'iptvx-ios',
    name: 'IPTVX',
    description: 'iPhone, iPad ve Apple TV için IPTV oynatıcı',
    setupType: 'Xtream API',
    logo: '/kurulum-icon/iptvx.jpg',
    loading: 'Elle Giriş',
    steps: [
      'IPTVX’i App Store’dan yükleyip açın.',
      '“Add Playlist” seçeneğine tıklayın.',
      '“Xtream API” seçeneğini seçin.',
      'Liste adı, sunucu URL’si, kullanıcı adı ve şifre bilgilerini girin.',
      'Bilgileri kaydedip oluşturulan listeyi açın.',
    ],
    actionUrl: 'https://apps.apple.com/tr/app/iptvx/id1451470024?l=tr',
    actionLabel: "App Store'dan İndir",
    actionExternal: true,
  }),

  'xtream-plugin': createGuide({
    id: 'xtream-plugin',
    name: 'Xtream Codes Plugin',
    description: 'Xtream Codes destekli uydu alıcıları',
    setupType: 'Cihaza göre Xtream Codes',
    logo: '/kurulum-icon/xtream%20logo.jpg',
    loading: 'Elle Giriş',
    steps: [
      'Cihaz modelinizin Xtream Codes desteğini kullanım kılavuzundan doğrulayın.',
      'Cihazınızla uyumlu IPTV eklentisini üreticinin resmî kaynağından yükleyin.',
      'Eklentiyi açıp yeni hesap ekleme seçeneğini seçin.',
      'Sunucu URL’si, kullanıcı adı ve şifre bilgilerini girin.',
      'Bilgileri kaydedip hesabı açın.',
      'Bilgi: Menü adları cihaz modeline ve yazılım sürümüne göre değişebilir.',
    ],
  }),

  nextstar: createGuide({
    id: 'nextstar',
    name: 'NextStar IPTV',
    description: 'M3U destekli NextStar uydu alıcıları',
    setupType: 'Cihaza göre M3U',
    logo: '/kurulum-icon/nextstar.png',
    loading: 'Manuel',
    steps: [
      'Cihaz modelinizin M3U desteğini kullanım kılavuzundan doğrulayın.',
      'Cihazın “IPTV” veya “Web TV” bölümünü açın.',
      '“Yeni Liste” veya “M3U URL” seçeneğini seçin.',
      'M3U bağlantınızı ilgili alana yapıştırıp kaydedin.',
      'Bilgi: Menü adları cihaz modeline ve yazılım sürümüne göre değişebilir.',
    ],
    hasM3u: true,
  }),

  'server-info': createGuide({
    id: 'server-info',
    name: 'Sunucu Bilgilerim',
    description: 'Sunucu URL’si, port, kullanıcı adı ve şifre',
    setupType: 'Bağlantı aracı',
    logo: '/kurulum-icon/sunucu.png',
    loading: 'Elle Giriş',
    steps: [
      'Uygulamada “Xtream Codes” veya “Portal Login” seçeneğini açın.',
      'Sunucu URL’si, port, kullanıcı adı ve şifre bilgilerini ilgili alanlara girin.',
      'Bilgileri kaydedip profilinizi açın.',
    ],
  }),

  m3u: createGuide({
    id: 'm3u',
    name: 'M3U Oluştur',
    description: 'Uygulamaya özel M3U bağlantısı',
    setupType: 'Bağlantı aracı',
    logo: '/kurulum-icon/m3u.png',
    loading: 'Elle Giriş',
    steps: [
      'Uygulamanızın M3U veya Playlist URL desteğini doğrulayın.',
      'İçerik ve logo seçeneğini belirleyin.',
      'M3U bağlantınızı oluşturun.',
      'Bağlantıyı uygulamadaki Playlist URL alanına yapıştırıp kaydedin.',
    ],
    hasM3u: true,
  }),
};

export const getSetupDetailGuide = (device) => {
  if (typeof device !== 'string') return null;

  let decodedDevice = device;
  try {
    decodedDevice = decodeURIComponent(device);
  } catch (error) {
    // Hatalı encode edilmiş doğrudan URL'lerde ham slug ile eşleşmeyi dene.
  }

  const normalizedDevice = decodedDevice.trim().toLowerCase();
  return SETUP_DETAIL_GUIDES[normalizedDevice] || null;
};
